import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            userPermissions: 'user/permissions'
        })
    },

    methods: {
    	checkPermission(name, permission) {
    		if(typeof this.userPermissions == 'object' && typeof this.userPermissions[name] !== 'undefined' && this.userPermissions[name][permission] !== 'undefined') {
                return this.userPermissions[name][permission];
            }
    		return false;
    	}
    },
}



// WEBPACK FOOTER //
// ./src/mixins/permissions.js